export const toCents = (amount: number) => Math.round(amount * 100);
export const toEuros = (amount: number) => Math.round(amount) / 100;
